<template>
  <v-card-text class="pt-2">
    <h1
      v-heading
      style="width: 320px;"
    >
      Passwort vergessen?
    </h1>


    <VForm>
      <v-row>
        <!-- email -->

        <v-col
          cols="12"
          v-if="refStep == 1"
        >
          <p class="mb-2">
            Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.
          </p>

          <VTextField
            v-model="form.email"
            label="E-Mail-Adresse"
            type="email"
            name="email"
            required
          />

          <Button
            block
            @click="sendRecovery"
            :loading="isLoading"
            class="mt-5"
          >
            Passwort zurücksetzen
          </Button>
        </v-col>

        <!-- email sent -->

        <v-col
          cols="12"
          v-if="refStep == 2"
        >
          <v-alert
            text="Bitte folgen Sie den Anweisungen in der E-Mail."
            type='info'
          />
        </v-col>

        <!-- password -->

        <v-col
          cols="12"
          v-if="refStep == 3"
        >
          <p class="mb-2">
            Bitte legen Sie neues Passwort fest.
          </p>

          <VTextField
            v-model="form.password"
            label="Passwort"
            required
            type="password"
            class="mb-5"
            min-length="8"
            @update:model-value="passwordValidator"
          />
          <VTextField
            v-model="form.passwordRepeat"
            label="Passwort wiederholen"
            required
            placeholder="············"
            type="password"
            min-length="8"
            @update:model-value="passwordValidator"
          />

          <!-- login button -->
          <Button
            block
            @click="setNewPassword"
            class="mt-5"
            :loading="isLoading"
          >
            Absenden
          </Button>
        </v-col>
        <v-col
          cols="12"
          v-if="showError"
        >
          <v-alert
            :text="errorText"
            type="error"
          ></v-alert>
        </v-col>

        <!-- create account -->
        <v-col
          cols="12"
          class="text-center text-base"
        >
          <RouterLink
            class="text-primary ms-2"
            to="/auth/login"
          >
            Zurück zum Login
          </RouterLink>
        </v-col>
      </v-row>
    </VForm>
  </v-card-text>

</template>

<script setup lang="ts">
import { useStorage } from '@vueuse/core'

definePageMeta({
  layout: 'default-auth'
});

const route = useRoute();
const showError = ref(false);
const supabase = useSupabaseClient();
const refStep = ref(route.query.step || 1);
const token = ref(route.query.token);
const email = useStorage('email', '');
const errorText = ref('');
const isLoading = ref(false);

const form = ref({
  email: email.value,
  passwordRepeat: '',
  password: ''
})

const setNewPassword = async () => {
  showError.value = false;

  if (!form.value.passwordRepeat || !form.value.password
    || form.value.password !== form.value.passwordRepeat
    || form.value.password.length < 8
  ) {
    showError.value = true;
    errorText.value = 'Bitte geben Sie ein gültiges Passwort ein';

    return false;
  }

  isLoading.value = true;

  const { data, error } = await supabase.auth.updateUser(
    {
      password: form.value.password
    });

  if (!error) {
    return navigateTo('/auth/login');
  } else {
    showError.value = true;
    errorText.value = error?.message || 'Ein Fehler ist aufgetreten';
  }

  isLoading.value = false;
}

const passwordValidator = () => {
  showError.value = form.value.password !== form.value.passwordRepeat;
  errorText.value = 'Die Passwörter stimmen nicht überein';
}

const sendRecovery = async () => {
  isLoading.value = true;
  showError.value = false;

  email.value = form.value.email;

  if (!form.value.email) {
    showError.value = true;
    errorText.value = 'Bitte geben Sie Ihre E-Mail-Adresse ein';
    isLoading.value = false;
    return;
  }

  try {
    const response: { success: boolean } = await $fetch('/api/auth/send-recovery', {
      method: 'POST',
      body: JSON.stringify({
        email: form.value.email
      })
    });

    if (response.success) {
      refStep.value = 2;
    } else {
      showError.value = true;
      errorText.value = 'Ein Fehler ist aufgetreten';
    }
  } catch (error) {
    showError.value = true;
    errorText.value = error?.message || 'Ein Fehler ist aufgetreten';
  }

  isLoading.value = false;
}

onMounted(async () => {
  if (token && refStep.value == 3) {
    if (!email.value) {
      console.log('no email', email.value);
      showError.value = true;
      errorText.value = 'Ein Fehler ist aufgetreten';
    } else {
      const { data, error } = await supabase.auth.verifyOtp({
        email: form.value.email,
        token: token.value,
        type: 'recovery'
      });

      if (error) {
        showError.value = true;
        errorText.value = error?.message || 'Ein Fehler ist aufgetreten';
      }
    }
  }
});

</script>
